import doctor0 from "../static/images/doctorLogo/doctor-0.png";
import doctor1 from "../static/images/doctorLogo/doctor-1.png";
import doctorNull from "../static/images/doctorLogo/doctor-null.png";

export const SMALL = "SMALL";
export const MEDIUM = "MEDIUM";
export const LARGE = "LARGE";

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
const OFFICE_IMAGE_BASE_URL = process.env.REACT_APP_OFFICE_IMAGE_BASE_URL;

function getEmptyImage(gender) {
  switch (gender) {
    case false:
      return doctor0;
    case true:
      return doctor1;
    default:
      return doctorNull;
  }
}

export function getProfileImageURL(picPath, size, gender, type = "") {
  if (!picPath) {
    return getEmptyImage(gender);
  }
  const imageName = picPath.lastIndexOf(".");
  switch (size) {
    case SMALL:
      return `${type === "officeImage" ? OFFICE_IMAGE_BASE_URL : IMAGE_BASE_URL}/cached/doctors/${picPath.substring(
        0,
        imageName
      )}_90x120${picPath.substring(imageName)}`;
    case MEDIUM:
      return `${type === "officeImage" ? OFFICE_IMAGE_BASE_URL : IMAGE_BASE_URL}/cached/doctors/${picPath.substring(
        0,
        imageName
      )}_150x200${picPath.substring(imageName)}`;
    case LARGE:
      return `${type === "officeImage" ? OFFICE_IMAGE_BASE_URL : IMAGE_BASE_URL}/uploads/doctors/${picPath}`;

    default:
      return `${type === "officeImage" ? OFFICE_IMAGE_BASE_URL : IMAGE_BASE_URL}/${picPath}`;
  }
}
